import { type UseQueryResult, useQuery } from 'react-query';
import {
  EsppOfferingPeriodService,
  PagedResultDto_EsppOfferingPeriodRow,
  // eslint-disable-next-line camelcase
} from '../../services/wealthlane-award-services';
import { TableParams, type TableParamsType } from '../../types/common';

const useGetOfferingPeriod = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_EsppOfferingPeriodRow | undefined,
  unknown
> => {
  const {
    offeringPeriodStartDate,
    offeringPeriodEndDate,
    status,
    offeringPeriodType,
    lookback,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    planIds,
    _force,
  } = tableInfo;

  const offeringPeriodList = useQuery(
    [
      'getOfferingPeriodList',
      offeringPeriodStartDate,
      offeringPeriodEndDate,
      status,
      offeringPeriodType,
      lookback,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      planIds,
      _force,
    ],
    async () => {
      return await handleRequest(
        EsppOfferingPeriodService.getApiAwardApiAwardOfferingPeriod(
          offeringPeriodStartDate,
          offeringPeriodEndDate,
          status,
          offeringPeriodType,
          planIds,
          lookback,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return offeringPeriodList;
};

export default useGetOfferingPeriod;
